import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const deleteNotification = (notificationId) => {
  return apiRequestType(
    apiTypes.DELETE,
    apiConstants.ADMIN.ENGAGEMENT_CENTER.DELETE_NOTIFICATION(notificationId)
  );
};

export default deleteNotification;
